import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getWarehouseTransferReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import { reportwarehouseTransfer } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class WarehouseTransfer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };

        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `WarehouseTransferBeginDate`);
        this.props.formInput(date, `WarehouseTransferEndDate`)
        this.props.clearFormInput(`WarehouseTransferBranchOption`);
        this.props.clearFormInput(`WarehouseTransferAction`);
    }

    cleanSearch = () => {
        this.props.clearFormInput(`WarehouseTransferBeginDate`);
        this.props.clearFormInput(`WarehouseTransferEndDate`);
        this.props.clearFormInput(`WarehouseTransferBranchOption`);
        this.props.clearFormInput(`WarehouseTransferAction`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let fromBranch = this.props.fromBranch || 0;
        let toBranch = this.props.toBranch || 0;
        let transfer = this.props.transfer;
        let warehouse = this.props.warehouse || 1;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let action = this.props.action || 1;
        let selectCannabis = this.props.isCannabis;

        if (transfer == 1 && (fromBranch != toBranch)) {
            alert("From branch and to branch must be equal for In-Branch transfers.");
            return;
        } else if (transfer == 1 && fromBranch == 0 && toBranch == 0) {
            alert("You must select from branch and to branch to view In-Branch transfers");
            return;
        }

        this.props.getWarehouseTransferReport({ beginDate, endDate, pageNumber, pageSize, fromBranch, toBranch, transfer, warehouse, action, selectCannabis });
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let fromBranch = this.props.fromBranch || 0;
        let toBranch = this.props.toBranch || 0;
        let action = this.props.action || 1;
        let transfer = this.props.transfer;
        let warehouse = this.props.warehouse || 1;
        let selectCannabis = this.props.isCannabis;

        if (transfer == 1 && (fromBranch != toBranch)) {
            alert("From branch and to branch must be equal for In-Branch transfers.");
            return;
        } else if (transfer == 1 && fromBranch == 0 && toBranch == 0) {
            alert("You must select from branch and to branch to view In-Branch transfers");
            return;
        }

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/warehouseexchange?beginDate=${beginDate}&endDate=${endDate}&fromBranchId=${fromBranch}&toBranchId=${toBranch}&transfer=${transfer}&warehouse=${warehouse}&reportaction=${action}&selectCannabis=${selectCannabis}`, "transfer");
        }
    }
    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    render() {
        const totalRow = this.props.warehouseTransfer && this.props.warehouseTransfer.list && this.props.warehouseTransfer.list.length > 0 ? this.props.warehouseTransfer.totalRows : 0;

        return (
            <Grid headerContent={reportwarehouseTransfer}>
                <PageHeader title={LOOKUP.report.warehouseTransfer.text} 
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-between-branch-transfer-report" />}
                    description={LOOKUP.report.warehouseTransfer.description}
                />
                <Header
                    loggedBranch={this.props.loggedBranch} reportactions={this.props.reportactions} branchOptions={this.props.brachOptions}
                    transferOptions={this.props.transferOptions} warehouseOptions={this.props.warehouseOptions} isCannabisOptions={this.props.isCannabisOptions}
                    filter={this.filter} download={this.downloadReport} showBody={this.showBody} />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body warehouseTransfer={this.props.warehouseTransfer} beginDate={this.props.beginDate} endDate={this.props.endDate} branchOptions={this.props.brachOptions} />
                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    brachOptions.push({ text: "All", value: "0" });
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    let reportactions = [
        {
            text: "Sent/Received", value: "1"
        },
        {
            text: "Received", value: "2"
        },
        {
            text: "Sent", value: "3"
        }
    ]
    let transferOptions = [
        {
            text: "In-Branch Transfer", value: "1"
        },
        {
            text: "Between-Branch Transfer", value: "2"
        }
    ]
    let warehouseOptions = [
        {
            text: "Storage", value: "1"
        },
        {
            text: "Store", value: "2"
        },
        {
            text: "Damage", value: "3"
        },
        {
            text: "All", value: "4"
        }
    ]
    let isCannabisOptions = [
        {
            text: "All", value: "0"
        },
        {
            text: "Cannabis", value: "1"
        },
        {
            text: "Non Cannabis", value: "2"
        }
    ]
    return {
        brachOptions: brachOptions,
        warehouseTransfer: state.reports.warehouseTransfer,
        loggedBranch: state.common.branchId,
        action: state.form.WarehouseTransferAction,
        beginDate: state.form.WarehouseTransferBeginDate,
        endDate: state.form.WarehouseTransferEndDate,
        fromBranch: state.form.WarehouseTransferFromBranch,
        toBranch: state.form.WarehouseTransferToBranch,
        transfer: state.form.WarehouseTransferTransfer,
        warehouse: state.form.WarehouseTransferWarehouse,
        isCannabis: state.form.WarehouseTransferIsCannabis,
        reportactions: reportactions,
        transferOptions: transferOptions,
        warehouseOptions: warehouseOptions,
        isCannabisOptions: isCannabisOptions
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getWarehouseTransferReport: model => dispatch(getWarehouseTransferReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(WarehouseTransfer));